// extracted by mini-css-extract-plugin
module.exports = {"list-item":"_936541","list-item__link":"_53811a","list-item__content":"ed8c98"};